var exports = {
  "Y": "Eyebrow__NfADzl",
  "I": "Icon__nNXsqM",
};

module.exports = exports;
